import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field } from "formik";
import Select from 'web/components/form-elements/Select';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import { Modal, ModalBody } from 'reactstrap';
import { RetryModalContentWrapper } from "./modalStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";
import RadioButton from 'web/components/form-elements/RadioButton';
import { fetchPaymentMethodsApi, retryPaymentApi } from "redux/actions/myPickupOrders";

function RetryPaymentModal(props) {
    const { modalData } = props
    const token = localStorage.getItem("token")
    const dispatch = useDispatch();
    let history = useHistory();
    const [loader, setLoader] = useState(false)
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
    const [initialValues, setInitialValues] = useState()
    const [paymentMethodsList, setPaymentMethodsList] = useState([])
    const [achBackupCardsList, setAchBackupCardsList] = useState([])
    const [alertModal, setAlertModal] = useState(false)
    const [alertModalContent, setAlertModalContent] = useState('')
    const [alertModalType, setAlertModalType] = useState()

    useEffect(() => {
        fetchPaymentMethods()
    }, [])

    const fetchPaymentMethods = async () => {
        setLoader(true)
        let response
        let data = { authId: localStorage.getItem('authId') }
        response = await dispatch(fetchPaymentMethodsApi(data, token));
        if (response?.success) {
            setLoader(false)
            let cardDetailsListTemp = [], achAccountDetailsTemp, defaultPaymentId, isAchSelected = false
            if (response?.data?.cardDetails?.length > 0) {
                cardDetailsListTemp = response?.data?.cardDetails?.map(data => {
                    if (data.defaultPayment) {
                        defaultPaymentId = data.id
                    }
                    return (
                        {
                            value: data.id,
                            label: `${data.brandName?.charAt(0).toUpperCase() + data.brandName.slice(1)} ending in ${data.last4Digit}, expires ${data.expMonth}/${data.expYear}`,
                            defaultPayment: data.defaultPayment,
                            type: data.paymentMethod
                        }
                    )
                })
                setAchBackupCardsList([...cardDetailsListTemp])
            }
            if (response?.data?.achDetails?.length > 0) {
                achAccountDetailsTemp = response?.data?.achDetails?.map(data => {
                    if (data.defaultPayment) {
                        defaultPaymentId = data.id
                        isAchSelected = true
                    }
                    return (
                        {
                            value: data.id,
                            label: 'Account Number: ******' + data.last4Digit + ' Bank Routing Number: ******' + data.routingNumber,
                            type: data.paymentMethod,
                            defaultPayment: data.defaultPayment
                        }
                    )
                })
                if (achAccountDetailsTemp) {
                    cardDetailsListTemp.push(achAccountDetailsTemp)
                }
            }
            if (cardDetailsListTemp) setPaymentMethodsList(cardDetailsListTemp.flat())

            //set the formik initial values                
            setInitialValues({
                paymentMethodId: defaultPaymentId,
                achBackUpCard: '',
                achSelected: isAchSelected,
                achAcknowledgeCheck: false,
            })
        } else {
            setLoader(false)
            if (response?.statusCode === 401) {
                history.push('./sign-in')
            } else {
                setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
                setAlertModal(!alertModal);
            }
        }
    }

    const submitForm = async (values) => {
        setLoader(true)
        let data = {
            orderId: modalData?.orderId,
            locationId: localStorage.getItem('locationID'),
            paymentMethodId: values?.paymentMethodId,
            backupPaymentMethodId: values?.achSelected ? values?.achBackUpCard : null,
        }
        let response
        response = await dispatch(retryPaymentApi(data, token));
        if (response?.success) {
            setLoader(false)
            setAlertModalType('retrySuccess')
            setAlertModalContent(response?.data?.msg);
            setAlertModal(!alertModal)
        } else {
            setLoader(false)
            if (response?.statusCode === 401) {
                history.push('./sign-in')
            } else {
                setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
                setAlertModal(!alertModal);
            }
        }
    }

    const checkIsValid = (formikProps) => {
        if (!formikProps.values?.achSelected) return false
        else {
            if (formikProps.values?.achAcknowledgeCheck && formikProps?.values?.achBackUpCard !== '') return false
            return true
        }
    }

    return (
        <div>
            {initialValues &&
                <Modal isOpen={true} centered={true} size={'lg'} className="cancel-reschedule-modal-style">
                    <RetryModalContentWrapper>
                        <ModalBody>
                            {(loaderVisible || loader) && <Spinner />}
                            <Formik
                                initialValues={initialValues}
                            >
                                {(formikProps) => {
                                    const { isValid, dirty, setFieldValue, values, errors, setFieldError } = formikProps;
                                    return (
                                        <div className="outer-wrapper">
                                            <div className="main-header">
                                                <h4>Retry Payment</h4>
                                                <img src={CloseIcon} alt="close-icon" onClick={() => props.closeModal()} />
                                            </div>
                                            {(paymentMethodsList.length === 0) ?
                                                <div className="no-pay-styles">
                                                    No payment methods found. <span onClick={() => history.push('/manage-account')}>Click here</span> to add payment details.
                                                </div>
                                                :
                                                <div className="content-wrapper">
                                                    {paymentMethodsList?.map((value, index) => {
                                                        return (
                                                            <Field
                                                                component={RadioButton}
                                                                name='paymentMethodId'
                                                                className="radio-label"
                                                                id={value.value}
                                                                onSelect={(e) => {
                                                                    let paymentOptionTemp = [], isAchSelected
                                                                    paymentOptionTemp = paymentMethodsList.filter(data => data.value === e.target.value)
                                                                    if (paymentOptionTemp?.length > 0) isAchSelected = paymentOptionTemp[0].type === 'ACH_ACCOUNT'
                                                                    if (isAchSelected) setFieldValue('achSelected', true)
                                                                    else setFieldValue('achSelected', false)
                                                                }}
                                                                label={value.label}
                                                            />
                                                        )
                                                    })}
                                                    {formikProps.values?.achSelected &&
                                                        <div>
                                                            <div className='ach-wrapper'>
                                                                <p>Select a backup card for ACH*</p>
                                                                <Select
                                                                    name="achBackUpCard"
                                                                    data={achBackupCardsList}
                                                                    placeholder='Select a card'
                                                                    onChangeHandler={(data) => { }}
                                                                />
                                                            </div>
                                                            <div>
                                                                <CheckboxInput
                                                                    name="achAcknowledgeCheck"
                                                                    label="I authorize that you can withdraw funds from my ACH account. If it fails, you can use my credit card."
                                                                    handleSelect={() => { }}
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="submit-button">
                                                        <button
                                                            disabled={checkIsValid(formikProps)}
                                                            onClick={() => submitForm(formikProps.values)}
                                                        >Submit</button>
                                                    </div>
                                                    <p className="add-new-styles" onClick={() => history.push('/manage-account')}>
                                                        To add new payment information.&nbsp;<span>Click Here</span>
                                                    </p>
                                                </div>}
                                        </div>
                                    );
                                }}
                            </Formik>
                        </ModalBody>
                    </RetryModalContentWrapper>
                </Modal>
            }
            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                content={alertModalContent}
                alertType='success'
                callBackAlert={() => {
                    if (alertModalType === 'retrySuccess') {
                        props.closeModal()
                        props.retryPaymentSuccessCallback()
                    }
                }}
            />
        </div>
    );
}

export default RetryPaymentModal;
